import { createListenerMiddleware } from '@reduxjs/toolkit'
import type { AppStartListening as CommonAppStartListening } from '../store'
import type { AppStartListening as PlayerProfileAppStartListening } from '../store.player-profile'
import { addFantasyInSeasonSpecificListeners } from '../listeners/fantasy-in-season/in-season-specific-listeners'
import { addConnectListeners } from '../listeners/connect'
import { addPlayerProfileListener } from '../listeners/player-profile'
import { addAccountsListeners } from '../listeners/accounts'

export const listenerMiddleware = createListenerMiddleware()

const startAppListening = listenerMiddleware.startListening as CommonAppStartListening

addFantasyInSeasonSpecificListeners(startAppListening)
addConnectListeners(startAppListening)
addPlayerProfileListener(listenerMiddleware.startListening as PlayerProfileAppStartListening)
addAccountsListeners(startAppListening)
